import { render, staticRenderFns } from "./new-connection-pricing-product.vue?vue&type=template&id=51ca6690&scoped=true&"
import script from "./new-connection-pricing-product.vue?vue&type=script&lang=js&"
export * from "./new-connection-pricing-product.vue?vue&type=script&lang=js&"
import style0 from "./new-connection-pricing-product.vue?vue&type=style&index=0&id=51ca6690&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ca6690",
  null
  
)

export default component.exports